export const MAIN_ENTRY_PAGES = ['dashboard', 'dashboard-notfunded'];
export const EDIT_PAYEE_ENTRY_PAGES = ['payees'];
